module.exports = __webpack_public_path__ + "media/images/barbecue_space-a80e0810cbe82d75349b90f56b21e066.png";